const defaultOrder = ['client', 'partners', 'directory', 'toolkit', 'announcement', 'gallery', 'faq'] as const;

type OrderType = typeof defaultOrder[number];

export function sortKeysByOrder<T extends Record<string, unknown>>(obj: T): string[] {
  return Object.keys(obj)
    .filter(k => defaultOrder.includes(k as OrderType))
    .sort((a, b) => defaultOrder.indexOf(a as OrderType) - defaultOrder.indexOf(b as OrderType));
}